import styled from 'styled-components'
import { RadioGroup as BaseRadioGroup } from '@ur-solutions/react-components'
import { Checkbox as BaseCheckbox } from '@ur-solutions/react-components'

interface RadioGroupProps {
  padding?: '1rem 0 0 0'
}

export const RadioGroup = styled(BaseRadioGroup)<RadioGroupProps>`
  padding: ${props => props.padding};
  i {
    top: 53%;
    left: 47%;
  }
`

export const RadioStyleCheckbox = styled(BaseCheckbox)`
  i {
    top: 55%;
    left: 50%;
  }
  .--checkbox-box {
    border-radius: 50%;
  }

  & > label {
    font-size: 0.9rem;
    font-weight: 600;
    color: ${props => props.theme.colors.gray5};
  }
`
